import Immutable from 'seamless-immutable';
import consts from './consts';

const CTXS = consts.CONTEXTS;

export const getNewList = () => ({
  items: [],
  page: 0,
  total: 0,
  inProgress: false,
  selected: [],
});

export const initialFilters = Immutable({
  withPeopleOnly: false,
  numberOfPeople: 2,
  size: 'medium',
  orientation: null,
  color: null,
  type: 'all',
  safe: true,
  category: 'all',
  duration: 'short',
  resolution: 'high_definition',
  gender: 'both',
});

export const initialPurchase = Immutable({
  plan: null,
  size: null,
  metadata: null,
});

export default () =>
  Immutable({
    __record: 'ShutterstockRecord',
    token: null,
    listeningForAuth: false,
    account: {
      user: null,
      name: null,
      subscriptions: [],
    },
    lists: {
      [CTXS.SEARCH]: getNewList(),
    },
    currentContext: CTXS.SEARCH,
    searchTermText: '', // the value being entered into the input
    searchTerm: '', // the value used for the last query
    mediaType: consts.MEDIA_TYPES.IMAGES,
    maxResults: consts.MAX_RESULTS.SELECTION,
    sort: consts.SORT_OPTIONS[0],
    filtersPanelOpen: false,
    filters: initialFilters,
    categories: [],
    purchase: initialPurchase,
    purchaseInProgress: false,
    purchaseSuccessUrl: null,
    assetsPurchaseDetails: {},
    retrievingDetails: false,
  });
